import script from "./AuthLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLoading.vue?vue&type=script&setup=true&lang=js"

import "./AuthLoading.vue?vue&type=style&index=0&id=389f0e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389f0e4e"]])

export default __exports__